module.exports = __webpack_public_path__ + "img/solar_pv_grey_line.d800ff90.png";